// extracted by mini-css-extract-plugin
export default {"container":"Wo-z","bubbleNav":"Xo-z","graphic":"Yo-z","contact":"Zo-z"};